import { render, staticRenderFns } from "./DiscoveryTableNextButton.vue?vue&type=template&id=9b42afc2&scoped=true&"
import script from "./DiscoveryTableNextButton.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTableNextButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b42afc2",
  null
  
)

export default component.exports